import { PayrunEmployeeStatus, PayrunStatus } from '$constants'
import dayjs, { Dayjs } from 'dayjs'
import { Nullable, StaffMember } from '$models'
import { setCompanyDayStartToDate } from '$utils'
import sortBy from 'lodash/sortBy'

export interface PayRun {
  id: string
  periodStartDate: Dayjs
  periodEndDate: Dayjs
  paymentDate: Dayjs
  employeesWorked: number
  employeesPaid: number
  loadedPay: number
  payrollPay: number
  payslipMessage?: Nullable<string>
  employees?: Employee[]
  status?: PayrunStatus
  payrollSystemCompanyId?: string
}

//This employee is only for Payruns for now
export type Employee = Partial<StaffMember> & {
  loadedWages: number
  payrollSystemWages: number
  status: PayrunEmployeeStatus
}

// Function to apply transformations to PayClassification object
export const transformPayRunOnGet = (payClassification: PayRun): PayRun => {
  return {
    ...payClassification,
    periodStartDate: setCompanyDayStartToDate(
      dayjs(payClassification.periodStartDate)
    ),
    periodEndDate: setCompanyDayStartToDate(
      dayjs(payClassification.periodEndDate)
    ),
    paymentDate: setCompanyDayStartToDate(dayjs(payClassification.paymentDate)),
    employees: payClassification.employees
      ? sortBy<Employee>(payClassification.employees, 'firstName', 'lastName')
      : [],
  }
}
